import test from "@/utils/pmRequest";

export function getMemberListApi (params) {
  return test({
    url: "/pm/team/getAllUser",
    method: "get",
    params
  });
}
/**
 * @desc: 所有可添加成员列表 
 * @param {*} params
 * @return {*}
 */
export function getAddUserList (params) {
  return test({
    url: "/pm/team/getAddUserList",
    method: "get",
    params
  });
}

export function addMemberApi (data) {
  return test({
    url: "/pm/team/addUser",
    method: "post",
    data
  });
}

export function removeMemberApi (data) {
  return test({
    url: "/pm/team/removeUser",
    method: "post",
    data
  });
}

export function editMemberApi (data) {
  return test({
    url: "/pm/team/editUser",
    method: "post",
    data
  });
}


